// extracted by mini-css-extract-plugin
export var deleteModal = "_dz-0";